
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.985 37.225l5.8-5.8 4.5-4.5c.3-.3 1.4-1.3 1.7-1.8.3.5 1.5 1.5 1.7 1.8l4.1 4.1 6.2 6.2c.9.9 1.3-2.1.7-2.7l-12.3-12.3c-.3-.3-.4-.3-.7 0l-12.4 12.4c-.6.5-.2 3.5.7 2.6z"}}),_c('path',{attrs:{"d":"M30.1 7C17.6 7 8 17.8 8 30s9.6 23 22.1 23c12.8 0 21.8-10.8 22.1-23C51.9 17.8 43 7 30.1 7zm0 42.9C19.3 49.9 9.4 41.1 9.4 30c0-10.9 9.5-19.5 20.1-19.9 11.3-.3 21.1 8.5 21.4 19.9-.3 11.1-9.7 19.9-20.8 19.9z"}})])
          )
        }
      }
    